import { TabletOpenLandscapeParams } from "../types/index-type";
import { initQueryselectorTablet } from "./init-queryselector-tablet";



const isHTMLElement = (element: Element | null): element is HTMLElement =>
  element instanceof HTMLElement;

export const initTabletOpenLandscape = ({
  wholeLeftPositionOpen,
  sidebarColumnsLandscape,
  mainColumnsLandscape,
}: TabletOpenLandscapeParams) => {
  const selectors = initQueryselectorTablet();
  const { body, grid, sideBarButton, codeArticle } = selectors;

  if (isHTMLElement(grid)) {
    grid.style.left = `${wholeLeftPositionOpen}vw`;
    grid.style.gridTemplateColumns = `${sidebarColumnsLandscape}vw ${mainColumnsLandscape}vw`;
  }

  codeArticle.forEach((article) => {
    article.style.width = "100%";
  });

  body?.classList.remove("sidebar-closed");
  body?.classList.add("sidebar-open");

  if (isHTMLElement(sideBarButton)) {
    sideBarButton.textContent = "CLOSE";
  }

  return selectors;
};
